// extracted by mini-css-extract-plugin
module.exports = {"heading":"App_heading__1pQob","test":"App_test__3_K_a","inside":"App_inside__1qBDb"};